import React, { Component } from 'react';
import { Input } from 'react-bootstrap';
import 'react-select/dist/react-select.css';

export class AfterAddonField extends Component {
  render() {
    const { input, options, onFocus } = this.props;
    if (onFocus != null) {
      return (
        <Input
          {...input}
          ref={(input) => { this.myInput = input; }}
          onKeyPress={this.props.onKeyPress}
          standalone
          type="text"
          addonAfter=".00"
          style={{ zIndex: 0 }}
          onFocus={onFocus}
        />
      );
    }
    return (
      <Input
        {...input}
        ref={(input) => { this.myInput = input; }}
        onKeyPress={this.props.onKeyPress}
        standalone
        type="text"
        addonAfter=".00"
        style={{ zIndex: 0 }}
      />
    );
  }
}

export class DisabledAfterAddonField extends Component {
  render() {
    const { input } = this.props;
    return (
      <Input {...input} standalone disabled type="text" addonAfter=".00" />
    );
  }
}

export class AfterAddonPercentField extends Component {
  render() {
    const { input } = this.props;
    return (
      <div>
        {this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}
        <Input {...input} ref={(input) => { this.myInput = input; }} standalone type="text" addonAfter="%" />
      </div>
    )
  }
}

export class AfterAddonPercentControlField extends Component {
  render() {
    let { input, onFocus, placeholder } = this.props;
    if (this.props.decimal) {
      let decimal = parseInt(this.props.decimal);
      placeholder = (parseFloat(placeholder) || 0).toFixed(decimal);
    }
    if (onFocus != null) {
      return (
        <div>
          {this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}
          <Input {...input} standalone type="text" ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} addonAfter="%" value={placeholder} onChange={this.props.onChange} onFocus={onFocus} />
        </div>
      );
    }
    return (
      <div>
          {this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}
          <Input {...input} standalone type="text" ref={(input) => { this.myInput = input; }} onKeyPress={this.props.onKeyPress} addonAfter="%" value={placeholder} onChange={this.props.onChange} />
      </div>
    );
  }
}

export default AfterAddonField;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/afterAddonField.jsx